<div class="dealer-info" *ngIf="dealer">
  <div class="d-flex">
    <div class="person-icon">
      <i class="material-icons">person</i>
    </div>
    <div class="w-100">
      <div class="dealer-name">{{ dealer.name }}</div>
      <div class="dealer-info-item" *ngIf="!isMarketplace && dealer.cpfCnpj">CPF/CNPJ {{ dealer.cpfCnpj }}</div>
      <div class="dealer-info-item-email" *ngIf="!isMarketplace">
        <div *ngFor="let email of dealer.emails">
          {{ email }}
        </div>
      </div>
      <div class="dealer-info-item" *ngIf="!isMarketplace">
        <div *ngFor="let phoneNumber of dealer.phoneNumbers">
          {{ phoneNumber }}
        </div>
      </div>
      <div class="dealer-info-item" *ngIf="dealer.city">{{ dealer.city }}/{{ dealer.uf }}</div>
      <!-- <div class="dealer-bid-value"><span class="currency-symbol">R$ </span>{{dealer.bidValue | number}}</div> -->
      <div class="value color" *ngIf="isMarketplace">
        <span class="currency-symbol">R$ </span>
        {{ dealer.bidValue | number }}
      </div>
      <mat-divider class="mt-1 mb-1" *ngIf="item?.message || item?.createdAt"></mat-divider>
      <div class="info" *ngIf="item?.message || item?.createdAt">
        <div *ngIf="item?.message" class="info-message">{{ item?.message }}</div>
        <div class="info-data">{{ item?.createdAt | amTimeAgo }}</div>
      </div>
    </div>
  </div>
</div>
